import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHeading,
  TableRow
} from '@vmware-react/clarity';
import React from 'react';
import { PRODUCT_NAME_CONSTANTS } from 'vrlcm-gui-constants';
import { l10n } from '../with-app-root/i18n/i18nUtil';
import './PreProductActionCheckList.css';

interface Props {
  linkActionButtons?: boolean;
  showSnapshotRecommendation?: boolean;
  showInventorySyncRecommendation?: boolean;
  onOpenProductSnapshot?: () => void;
  onTriggerInventorySync?: () => void;
}

const PreProductActionCheckList: React.SFC<Props> = props => {
  const {
    showInventorySyncRecommendation = true,
    showSnapshotRecommendation = true,
    onOpenProductSnapshot,
    onTriggerInventorySync,
    linkActionButtons
  } = props;
  return (
    <div>
      <Table orientation="vertical">
        <TableBody>
          {showInventorySyncRecommendation && (
            <TableRow>
              <TableHeading>
                {l10n(
                  'components.preProdActionChecklist.invSyncRecommendation',
                  [PRODUCT_NAME_CONSTANTS.lcm]
                )}
              </TableHeading>
              <TableCell>
                <Button
                  size="sm"
                  title={l10n('triggerInvSync')}
                  onClick={onTriggerInventorySync}
                  family={linkActionButtons ? 'link' : undefined}
                >
                  {l10n('triggerInvSync')}
                  {linkActionButtons && (
                    <clr-icon
                      shape="pop-out"
                      class="pre-product-action-check-list__pop-out-icon"
                    />
                  )}
                </Button>
              </TableCell>
            </TableRow>
          )}
          {showSnapshotRecommendation && (
            <TableRow>
              <TableHeading>
                {l10n(
                  'components.preProdActionChecklist.snapshotRecommendation'
                )}
              </TableHeading>
              <TableCell>
                <Button
                  size="sm"
                  title={l10n(
                    'components.preProdActionChecklist.takeProductSnapshot'
                  )}
                  onClick={onOpenProductSnapshot}
                  family={linkActionButtons ? 'link' : undefined}
                >
                  {l10n(
                    'components.preProdActionChecklist.takeProductSnapshot'
                  )}
                  {linkActionButtons && (
                    <clr-icon
                      shape="pop-out"
                      class="pre-product-action-check-list__pop-out-icon"
                    />
                  )}
                </Button>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <p>{l10n('components.preProdActionChecklist.invUpToDate')}</p>
    </div>
  );
};

export default PreProductActionCheckList;
